<template>
  <div class="dts-contanier">
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script setup lang="ts">
import { useStore } from 'vuex';

import { getUserInfo } from '@/api/login';
import { useUseCaseRouterHook } from '@/hooks/useUseCaseRouterHook';
const store = useStore();

useUseCaseRouterHook();

const init = () => {
  getUserInfo().then((res) => {
    window.localStorage.setItem('userInfo', JSON.stringify(res || {}));
    window.localStorage.setItem('rbacPriList', JSON.stringify(res.rbacPriList));
    store.commit('user/SET_PRILIST', res.rbacPriList);
    store.commit('user/SET_PRIVILEGEBTNS', res.privilegeBtns);
    store.commit('user/SET_ROLES', res.roles);
    store.commit('user/SET_NAME', res.name);
    store.commit('user/SET_ACCOUNT', res.account);
    store.commit('user/SET_ROLENAMES', res.roleNames);
    store.commit('user/SET_USERINFO', res);
  });
};
init();
</script>
<style>
.dts-contanier {
  background-color: #f7f8fd;
  padding: 32px 24px;
  position: relative;
  flex: 1;
  min-height: 100vh;
}
</style>
